import { withTheme } from 'styled-components/macro'
import React from 'react'
import CircleButton from '../CircleButton/CircleButton'
import { MdRemoveCircle } from 'react-icons/md'
import PropTypes from 'prop-types'

const RemoveButton = React.memo(({ isactive, theme, size, show, ...rest }) => {
  if (!show) {
    return
  }

  const circleStyle = {
    zIndex: 2,
    width: size || '3.6rem',
    height: size || '3.6rem'
  }
  return (
    <CircleButton fill={theme.productMinusButtonIcon} size={size} {...rest}>
      <MdRemoveCircle
        style={circleStyle}
        color={theme.productMinusButtonBackground}
      />
    </CircleButton>
  )
})

RemoveButton.displayName = 'RemoveButton'

RemoveButton.propTypes = {
  isactive: PropTypes.bool,
  show: PropTypes.oneOfType([PropTypes.number, PropTypes.bool]),
  size: PropTypes.string,
  theme: PropTypes.object.isRequired
}

export default withTheme(RemoveButton)
export { RemoveButton }
